import React, { useState, useEffect } from "react";
import { useStateValue } from "../../../State";
import "../combinedplan.css";

import ContentBoxMUI from "../../../Components/ContentBoxMUI";
import ChildRow from "../../Vasu/ChildRow";
import DescriptionOfChildDetail from "./DescriptionOfChildDetail";
import Languages from "../../../translations";
import { getProfilePictureData } from "../../../utils";
import { getCombinedPlanSectionTitle } from "../sectionTitles";

import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const DescriptionOfChildPart = (props) => {
  const { state } = useStateValue();
  const combinedPlanData = state.combinedPlan.data;
  const DescriptionRows = combinedPlanData
    ? combinedPlanData.DescriptionOfChildRows
    : [];

  const { history, match } = props;
  const childId = match.params.ChildId;
  const child = state.children?.ChildList?.find((c) => c.Id === childId);
  const childpicture = getProfilePictureData(state, child?.Id);
  const childFirstName = child?.FirstName ?? null;
  const childLastName = child?.LastName ?? null;
  const childColor = child?.BgColor ?? null;
  const sectionTitle = getCombinedPlanSectionTitle(
    combinedPlanData,
    "description",
    combinedPlanData?.DescriptionOfChildSectionTitle,
  );

  const [ShowSlideIndex, setShowSlideIndex] = useState(-1);

  useEffect(() => {
    if (!combinedPlanData) {
      history.replace(`/combinedplan/${childId}`);
    }
  }, []);

  const handleBackClick = () => {
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = () => {
      window.history.pushState(null, "", window.location.href);
      setShowSlideIndex(-1);
      window.onpopstate = undefined;
      window.history.back();
    };
  };

  const handleBoxClick = (index) => {
    setShowSlideIndex(index);
    handleBackClick();
  };

  if (!combinedPlanData) {
    return <div className="CombinedPlanContainer"></div>;
  }

  const menuItems = [
    Languages.ChildStrengthsAndIterests,
    Languages.ChildWellbeingAndLearningObjectives,
    Languages.OtherImportanInfo,
  ];

  return (
    <div className="CombinedPlanContainer">
      <ContentBoxMUI>
        <Box sx={{ mt: 1 }}>
          <ChildRow
            childpicture={childpicture}
            childFirstName={childFirstName}
            childLastName={childLastName}
            childColor={childColor}
            FormId={combinedPlanData.PlanId}
            history={history}
          />
        </Box>

        {ShowSlideIndex === -1 ? (
          <div>
            <h4 className="textCenter">{sectionTitle}</h4>
            <List className="col-12" sx={{ mt: -1 }}>
              {menuItems.map((label, index) => (
                <ListItemButton
                  key={index}
                  className="boxed"
                  sx={{
                    backgroundColor: "#fbcece",
                    borderRadius: 0.5,
                    mt: 1.5,
                    boxShadow: 2,
                  }}
                  onClick={() => handleBoxClick(index)}
                >
                  <ListItemText
                    primaryTypographyProps={{
                      fontWeight: "Bold",
                      fontSize: 16,
                      ml: 2,
                    }}
                    primary={label}
                  />
                  <ListItemIcon>
                    <ArrowForwardIosIcon fontWeight="Bold" fontSize="small" />
                  </ListItemIcon>
                </ListItemButton>
              ))}
            </List>
          </div>
        ) : (
          <DescriptionOfChildDetail
            SelectedSlideIndex={ShowSlideIndex}
            rows={DescriptionRows}
            sectionTitle={sectionTitle}
          />
        )}
      </ContentBoxMUI>
    </div>
  );
};

export default DescriptionOfChildPart;
